var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14083 0.195737C0.879852 -0.0652456 0.456717 -0.0652456 0.195736 0.195737C-0.0652453 0.456719 -0.0652453 0.879855 0.195736 1.14084L4.0549 5.00002L0.195776 8.85916C-0.0652052 9.12014 -0.0652055 9.54328 0.195776 9.80426C0.456757 10.0652 0.879892 10.0652 1.14087 9.80426L5 5.94512L8.85913 9.80426C9.12011 10.0652 9.54324 10.0652 9.80422 9.80426C10.0652 9.54328 10.0652 9.12014 9.80422 8.85916L5.9451 5.00002L9.80426 1.14084C10.0652 0.879855 10.0652 0.456719 9.80426 0.195737C9.54328 -0.0652456 9.12015 -0.0652456 8.85917 0.195737L5 4.05492L1.14083 0.195737Z",
    fill: "#959CB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClose);
export default __webpack_public_path__ + "static/media/search-close.00452f47e671f396c06172312a0087f7.svg";
export { ForwardRef as ReactComponent };